var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useMemo } from 'react';
import getReadEditButtonCell from '../components/ReadEditButtonCell';
import { EditReadPosition } from '../types';
/**
 * Because in new design we are displaying lot of the controlls differently, including read and edit buttons in grid,
 * easiest way to make all the definition changes is to just overwrite the here once, instead of modifying every single grid (33 instances atm).
 * This will also allow to easily swap back to grid provided logic, if it becomes usable for redesigned grid or if design changes again
 * */
var useEditReadAsColumn = function (props) {
    var onRowAction = props.onRowAction, actionColumnDefinition = props.actionColumnDefinition, columnsDefinitions = props.columnsDefinitions, onRowEditClick = props.onRowEditClick, onRowReadClick = props.onRowReadClick;
    var modifiedActionColumnDefinition = useMemo(function () {
        var _a;
        if ((actionColumnDefinition === null || actionColumnDefinition === void 0 ? void 0 : actionColumnDefinition.forceCheckboxes) || ((_a = actionColumnDefinition === null || actionColumnDefinition === void 0 ? void 0 : actionColumnDefinition.actionOptions) === null || _a === void 0 ? void 0 : _a.length)) {
            // note: this also removes actions, because we render action trigger outside the grid anyway
            return { flexBasis: 40, forceCheckboxes: true, addRowNumbers: actionColumnDefinition === null || actionColumnDefinition === void 0 ? void 0 : actionColumnDefinition.addRowNumbers, checkAllPosition: 'top' };
        }
        else if (actionColumnDefinition === null || actionColumnDefinition === void 0 ? void 0 : actionColumnDefinition.addRowNumbers) {
            return { flexBasis: 40, addRowNumbers: true };
        }
        else {
            return undefined;
        }
    }, [actionColumnDefinition]);
    var modifiedOnRowAction = useCallback(function (id, field, value, rowData) {
        if (field === 'row_edit' || field === 'row_read') {
            if (field === 'row_edit' && onRowEditClick)
                onRowEditClick(id, value);
            if (field === 'row_read' && onRowReadClick)
                onRowReadClick(id, value);
        }
        else if (onRowAction) {
            return onRowAction(id, field, value, rowData);
        }
    }, [onRowAction, onRowEditClick, onRowReadClick]);
    // TODO Entire logic of row edit / row read need to be completely refactored.
    var CellComponent = useMemo(function () { return getReadEditButtonCell(actionColumnDefinition); }, [actionColumnDefinition]);
    var modifiedColumnsDefinitions = useMemo(function () {
        if ((actionColumnDefinition === null || actionColumnDefinition === void 0 ? void 0 : actionColumnDefinition.canRowEdit) !== undefined || (actionColumnDefinition === null || actionColumnDefinition === void 0 ? void 0 : actionColumnDefinition.canRowRead) !== undefined) {
            var stickTo = actionColumnDefinition.stickTo || 'right';
            var editReadColumnDefinition = {
                name: 'sticky',
                flexBasis: actionColumnDefinition.flexBasis || 88,
                filtering: false,
                sorting: false,
                sticky: true,
                stickTo: stickTo,
                alwaysOn: true,
                cellComponent: CellComponent
            };
            if (stickTo === EditReadPosition.Left) {
                return __spreadArray([editReadColumnDefinition], columnsDefinitions, true);
            }
            else {
                return __spreadArray(__spreadArray([], columnsDefinitions, true), [editReadColumnDefinition], false);
            }
        }
        else {
            return columnsDefinitions;
        }
    }, [CellComponent, actionColumnDefinition === null || actionColumnDefinition === void 0 ? void 0 : actionColumnDefinition.canRowEdit, actionColumnDefinition === null || actionColumnDefinition === void 0 ? void 0 : actionColumnDefinition.canRowRead, columnsDefinitions]);
    return {
        columnsDefinitions: modifiedColumnsDefinitions,
        actionColumnDefinition: modifiedActionColumnDefinition,
        onRowAction: modifiedOnRowAction
    };
};
export default useEditReadAsColumn;
